import { render } from "./DatePager.vue?vue&type=template&id=206261bd&scoped=true&ts=true"
import script from "./DatePager.vue?vue&type=script&lang=ts"
export * from "./DatePager.vue?vue&type=script&lang=ts"

import "./DatePager.vue?vue&type=style&index=0&id=206261bd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206261bd"]])

export default __exports__